import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import { useRouteError } from 'react-router';
import { Error500 } from './errors/500';

export const RootErrorBoundary = () => {
  const error = useRouteError() as Error;
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);
  return <Error500 />;
};
